import React from 'react';
export function Footer() {
  return <footer className="defer-paint w-full border-t border-line bg-navy pb-24 pt-10 sm:pb-10" data-id="element-114" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-115" data-mp="3gg0xpz2xhpvj">
        <p className="font-display text-2xl font-extrabold uppercase tracking-[0.12em] text-fg" data-id="element-116" data-mp="32oe3e4sjqrfe">
          Volleyball <span className="text-accent" data-id="element-117" data-mp="36oo87e4lrbso">360</span> Ready™
        </p>
        <p className="mt-2 font-display text-sm font-bold uppercase tracking-[0.24em] text-muted" data-id="element-118" data-mp="36n3grxdl48z1">
          Open → Choose → Set up → Coach
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-accent/50" aria-hidden="true" data-id="element-119" data-mp="37fth3568s26" />
        <p className="mt-6 text-sm leading-relaxed text-muted" data-id="element-120" data-mp="3lf56iolxxllc">
          © 2026 VOLLEYBALL 360 READY™ — All rights reserved.
        </p>
        <p className="mt-1 text-sm text-muted" data-id="element-121" data-mp="3qblxdqkiye24">
          Digital coaching system for volleyball coaches.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-xs leading-relaxed text-muted" data-id="element-122" data-mp="2a1jlnfn4665m">
          Results depend on how the system is applied in real training
          environments.
        </p>
      </div>
    </footer>;
}